import React from 'react'
import { CallToAction, Container, Paragraph } from '@scentregroup/ui'
import { promotionType } from '../../types'
import analyticsUtils from '../../helpers/analytics-utils'
import containerStyle from '../container.scss'
import FlipFlop from '../flip-flop'
import Article from '../article'
import ExternalLink from '../external-link'

const { GIFTCARD_CLICK, CORP_MODULE_CTA } = analyticsUtils.categories

const Promotion = ({
  image,
  title,
  heading,
  shortDescription,
  callToActionLabel,
  callToActionAddress,
  eventCategory,
  eventAction,
  analyticsMetadata,
}) => (
  <Container type="large" className={containerStyle.container}>
    <FlipFlop
      position="right"
      size="full"
      imageUrl={image.url}
      lazyLoad={false}
      analyticsMetadata={analyticsMetadata}
    >
      <Article superheading={heading} heading={title}>
        <Paragraph>{shortDescription}</Paragraph>
        <CallToAction
          {...{
            rel: 'noopener',
            target: '_self',
          }}
          element={ExternalLink}
          url={callToActionAddress}
          eventCategory={eventCategory}
          eventAction={eventAction}
          eventLabel={callToActionLabel}
          data-test-id="promotion-link"
        >
          {callToActionLabel}
        </CallToAction>
      </Article>
    </FlipFlop>
  </Container>
)

Promotion.propTypes = promotionType.isRequired

Promotion.defaultProps = {
  eventCategory: GIFTCARD_CLICK,
  eventAction: CORP_MODULE_CTA,
}

export default Promotion
